/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForAzureEaApiKey extends models.ServiceAccountCredentialsBaseForAzureApiKey {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForAzureEaApiKey");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForAzureEaApiKey.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForAzureEaApiKey>): ServiceAccountCredentialsForAzureEaApiKey {
        let obj = Object.assign(new ServiceAccountCredentialsForAzureEaApiKey(), model);
        ServiceAccountCredentialsForAzureEaApiKey.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForAzureEaApiKey>): ServiceAccountCredentialsForAzureEaApiKey {
        if (!model) return null;
        return ServiceAccountCredentialsForAzureEaApiKey.newInstance(<ServiceAccountCredentialsForAzureEaApiKey> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForAzureEaApiKey) {
        if (!obj) return;

        models.ServiceAccountCredentialsForAzureEaApiKey.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForAzureEaApiKey): boolean {
        if (models.ServiceAccountCredentialsBaseForAzureApiKey.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForAzureEaApiKey.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
